import Vue from "vue";
import App from "./App";
import router from "./router";
import Cookies from "js-cookie";
import store from "./store";
import "@/permission";
// 引入iconfont图标
import "@/styles/iconfont/iconfont.css";
import "@/styles/iconfont/iconfont.js";
import "@/styles/iconfont/iconfont.json";
import "@/styles/iconfont/iconfont.ttf";
// 增加im组件
import MChat from "../src/packages/index";
// 引入Element-UI
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//加载全局api前缀配置
import baseUrls from "@/api/baseUrls";
//加载全局axios,tools配置
import { ajax, tools } from "@/utils/tools";
// 引入自定义组件
import DcPointComponents from "dc-point-components";
import "dc-point-components/dist/dc-point-components.css";

import directive from "./directive"; // directive
// 引入高德地图组件
//import VueAMap from "vue-amap";
// 引入公用的css
import "@/styles/commons.scss";
import "@/styles/index.scss"; // global css
// 引入vue-quill-editor富文本编辑器组件
import VueQuillEditor from "vue-quill-editor";
// 引入样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// 全局引入echarts
import * as echarts from "echarts";
import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

import { getDicts } from "@/api/system/dict/data";
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";
// 字典标签组件
import DictTag from "@/components/DictTag";
// 字典数据组件
import DictData from "@/components/DictData";

Vue.prototype.getDicts = getDicts;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.handleTree = handleTree;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectDictLabels = selectDictLabels;

Vue.prototype.$echarts = echarts;
Vue.prototype.baseUrls = baseUrls;
Vue.prototype.topsAjax = ajax;
Vue.prototype.topsTools = tools;
Vue.prototype.dcAjax = ajax;
Vue.use(Element, {
  size: Cookies.get("size") || "medium", // set element-ui default size
});
Vue.use(directive);
Vue.use(MChat);
Vue.use(VideoPlayer);
Vue.use(DcPointComponents);
Vue.use(VueQuillEditor);
//Vue.use(VueAMap);

Vue.component("DictTag", DictTag);

Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
      const value = binding.value
      console.log(value);
      if (value == false) return
      // 获取拖拽内容头部
      const dialogHeaderEl = el.querySelector('.el-dialog__header');
      const dragDom = el.querySelector('.el-dialog');
      dialogHeaderEl.style.cursor = 'move';
      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
      dragDom.style.position = 'absolute';
      dragDom.style.marginTop = 0;
      let width = dragDom.style.width;
      if (width.includes('%')) {
          width = +document.body.clientWidth * (+width.replace(/\%/g, '') / 100);
      } else {
          width = +width.replace(/\px/g, '');
      }
      dragDom.style.left = `${(document.body.clientWidth - width) / 2}px`;
      // 鼠标按下事件
      dialogHeaderEl.onmousedown = (e) => {
          // 鼠标按下，计算当前元素距离可视区的距离 (鼠标点击位置距离可视窗口的距离)
          const disX = e.clientX - dialogHeaderEl.offsetLeft;
          const disY = e.clientY - dialogHeaderEl.offsetTop;

          // 获取到的值带px 正则匹配替换
          let styL, styT;

          // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
          if (sty.left.includes('%')) {
              styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
              styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
          } else {
              styL = +sty.left.replace(/\px/g, '');
              styT = +sty.top.replace(/\px/g, '');
          };

          // 鼠标拖拽事件
          document.onmousemove = function (e) {
              // 通过事件委托，计算移动的距离 （开始拖拽至结束拖拽的距离）
              const l = e.clientX - disX;
              const t = e.clientY - disY;

              let finallyL = l + styL
              let finallyT = t + styT

              // 移动当前元素
              dragDom.style.left = `${finallyL}px`;
              dragDom.style.top = `${finallyT}px`;

          };

          document.onmouseup = function (e) {
              document.onmousemove = null;
              document.onmouseup = null;
          };
      }
  }
})

DictData.install();

// VueAMap.initAMapApiLoader({
//   key: "cfa98b8a4ae59e6a107ac4a45982b5e9",
//   plugin: ["AMap.Riding", "AMap.Autocomplete", "AMap.PlaceSearch", "AMap.Scale", "AMap.OverView", "AMap.ToolBar", "AMap.MapType", "AMap.PolyEditor", "AMap.CircleEditor", "AMap.Geolocation"],
//   v: "2.0",
//   uiVersion: "1.0",
// });
// 高德API 安全秘钥设置
// window._AMapSecurityConfig = {
//   securityJsCode: "b8a4464b553cb5553823f3129e97aff3",
// };
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  document.title = process.env.VUE_APP_TITLE;
  next();
});
if (process.env.DEPLOYED_AT && !localStorage.getItem("deployedAt")) {
  document.cookie = `Authorization=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  localStorage.setItem("deployedAt", process.env.DEPLOYED_AT);
}
new Vue({
  router,
  store,
  mounted() {
    // 监听form提交事件
    document.addEventListener("submit", this.preventFormSubmit);
  },
  beforeDestroy() {
    // 移除监听器
    document.removeEventListener("submit", this.preventFormSubmit);
  },
  methods: {
    preventFormSubmit(event) {
      // 检查是否是在你希望允许提交的场景之外触发的提交
      // 例如，你可能想要允许在特定的表单或者特定的输入元素中按下回车时提交
      if (!this.shouldAllowSubmit(event)) {
        event.preventDefault();
      }
    },
    shouldAllowSubmit(event) {
      // 在这里添加你的逻辑来决定是否允许提交
      // 例如，你可以检查提交事件的源元素或者表单的特定属性
      // 这里是一个简单的示例，检查是否有一个特定的属性设置为允许提交
      const form = event.target;
      return form.dataset.allowSubmit === "true";
    },
  },
  render: (h) => h(App),
}).$mount("#app");
